// teacherAdminReducer.js

import {
  FETCH_TEACHERS_REQUEST,
  FETCH_TEACHERS_SUCCESS,
  FETCH_TEACHERS_FAILURE,
  FETCH_TEACHER_INFORMATION_SUCCESS,
  FETCH_TEACHER_INFORMATION_FAILURE,
  UPDATE_TEACHER_PROFILE_ATTRIBUTES_FAILURE,
  UPDATE_TEACHER_PROFILE_ATTRIBUTES_REQUEST,
  UPDATE_TEACHER_PROFILE_ATTRIBUTES_SUCCESS,
  SAVE_ADMIN_TEACHER_FAILURE,
  SAVE_ADMIN_TEACHER_REQUEST,
  SAVE_ADMIN_TEACHER_SUCCESS,
  UPLOAD_TEACHER_PROFILE_PICTURE_FAILURE,
  UPLOAD_TEACHER_PROFILE_PICTURE_REQUEST,
  UPLOAD_TEACHER_PROFILE_PICTURE_SUCCESS,
} from "../Actions/types";

const initialState = {
  loading: false,
  teachers: [], // A list of teachers
  error: null,
};

const teacherAdminReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TEACHERS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_TEACHERS_SUCCESS:
      return {
        ...state,
        loading: false,
        teachers: action.payload, // Set list of teachers
      };
    case FETCH_TEACHERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateTeacherDetails = {
  teacherDetails: null, // Add this for detailed teacher information
  loading: false,
  saving: false,
  uploadingPicture: false,
  error: null,
  saveError: null,
};

export const teacherDetailsAdminReducer = (
  state = initialStateTeacherDetails,
  action
) => {
  switch (action.type) {
    case FETCH_TEACHER_INFORMATION_SUCCESS:
      return {
        ...state,
        teacherDetails: action.payload,
        loading: false,
        error: null,
      };
    case FETCH_TEACHER_INFORMATION_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case UPDATE_TEACHER_PROFILE_ATTRIBUTES_REQUEST:
    case SAVE_ADMIN_TEACHER_REQUEST:
      return {
        ...state,
        saving: true,
        saveError: null,
      };
    case UPDATE_TEACHER_PROFILE_ATTRIBUTES_SUCCESS:
    case SAVE_ADMIN_TEACHER_SUCCESS:
      return {
        ...state,
        teacherDetails: action.payload,
        saving: false,
        saveError: null,
      };
    case UPDATE_TEACHER_PROFILE_ATTRIBUTES_FAILURE:
    case SAVE_ADMIN_TEACHER_FAILURE:
      return {
        ...state,
        saving: false,
        saveError: action.payload,
      };
    case UPLOAD_TEACHER_PROFILE_PICTURE_REQUEST:
      return {
        ...state,
        uploadingPicture: true,
        saveError: null,
      };
    case UPLOAD_TEACHER_PROFILE_PICTURE_SUCCESS:
      return {
        ...state,
        teacherDetails: action.payload,
        uploadingPicture: false,
        saveError: null,
      };
    case UPLOAD_TEACHER_PROFILE_PICTURE_FAILURE:
      return {
        ...state,
        uploadingPicture: false,
        saveError: action.payload,
      };
    default:
      return state;
  }
};

export default teacherAdminReducer;
